import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=7e25f402"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports